import React from "react";
import {Button, Col, List, Popconfirm, Typography} from "antd";
import {FileOutlined, PlusOutlined} from "@ant-design/icons";
import {ASSET_BASE_URL} from "../../../../configs/AppConfig";
import moment from "moment";

const {Text, Title} = Typography

export class FicheDocs extends React.Component {


    render() {
        const {selected, fiche} = this.props

        if (!selected) {
            return null
        }

        if (selected.docs.length === 0) {
            return null
        }

        return (
            <Col>
                <Col style={{display: "flex", justifyContent: "flex-end", marginBottom: 30}}>
                    <Button type="primary" icon={<PlusOutlined/>} onClick={() => fiche.modalAddDoc.show(selected.id)}>Ajouter
                        un document</Button>
                </Col>
                <List
                    grid={{gutter: 16, column: 2}}
                    itemLayout="horizontal"
                    dataSource={selected.docs}
                    renderItem={item => (
                        <List.Item actions={[
                            <Popconfirm
                                title="Êtes-vous sûrs de vouloir supprimer ce document ?"
                                onConfirm={() => fiche.onDelete(item.id, "document")}
                                okText="Oui"
                                cancelText="Non"
                                okType={"danger"}
                            >
                                <a href="#" onClick={() => {
                                }}>Supprimer</a>
                            </Popconfirm>
                        ]}>

                            <List.Item.Meta
                                style={{cursor: "pointer"}}
                                avatar={<FileOutlined/>}
                                title={<a href={ASSET_BASE_URL + "/" + item.doc}
                                          target={"_blank"}
                                          rel="noreferrer">{item.name}</a>}
                                description={moment(item.datetime).format("dddd DD MMMM YYYY")}
                            />
                        </List.Item>
                    )}
                />
            </Col>
        )
    }
}
